module.exports = __webpack_public_path__ + "img/ic_exam_thumb.00e7f69d.png";